<div class="header-container">
  <span class="image" [style.backgroundImage]="'url('+logo+')'"></span>
  <div class="header-text">
    <h3>{{"WHITE_LABEL_DASHBOARD.PDF.REPORT" | translate}}</h3>
    <h6>
      <span>{{"WHITE_LABEL_DASHBOARD.PDF.FROM" | translate}} {{filter?.date?.start | dateFormatter}}</span>
      <span *ngIf="filter?.date?.range != 'today'">{{"WHITE_LABEL_DASHBOARD.PDF.TO" | translate}} {{filter?.date?.end | dateFormatter}}</span>
    </h6>
  </div>
</div>
